import { IDENTIFIERS } from '../../../types/Identifiers';
import { updateValueByIdentifier } from '../../../tags/values/update-by-identifier';
import { get, getRawValue } from '../../../utils/get';
import { getKeys, siteIDs, hasMissingSchemaVariables, } from '../../../adapters/utils';
import { renderStructureData } from './structured-data/render-structured-data';
export var IDs = {
    INDEX_POST: 'blog-post.index',
    TITLE: 'blog-post.title',
    HEADLINE: 'blog-post.headline',
    DESCRIPTION: 'blog-post.description',
    POST_PAGE_URL: 'blog-post.url',
    COVER_IMAGE: 'blog-post.cover.image',
    COVER_IMAGE_HEIGHT: 'blog-post.cover.image.height',
    COVER_IMAGE_WIDTH: 'blog-post.cover.image.width',
    AUTHOR: 'blog-post.author',
    AUTHOR_IMAGE_URL: 'blog-post.author.image.url',
    AUTHOR_IMAGE_HEIGHT: 'blog-post.author.image.height',
    AUTHOR_IMAGE_WIDTH: 'blog-post.author.image.width',
    PUBLISHER_ID: 'blog-post.publisher.id',
    PUBLISHER_NAME: 'blog-post.publisher.name',
    PUBLISH_DATE: 'blog-post.publish.date',
    LAST_MODIFIED_DATE: 'blog-post.modified.date',
    AMP_URL: 'blog-post.amp.url',
    DISABLE_SCHEMA: 'blog-post.disable-schema',
    DISABLE_AMP: 'blog-post.disable-amp',
    CATEGORIES: 'blog-post.categories',
    SD_DISABLE_SCHEMA: 'blog-post.disable-schema',
    SD_JSON_RENDER: 'blog-post.structured-data.render',
};
var userVisible = [];
var requiredSchemaVariables = [siteIDs.BUSINESS_LOGO, siteIDs.SITE_NAME];
export default {
    IDs: IDs,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var data = (_a = {},
            _a[IDs.INDEX_POST] = getRawValue(item, "post.noIndex") ? 'noindex' : '',
            _a[IDs.TITLE] = get(item, 'post.title'),
            _a[IDs.HEADLINE] = get(item, 'post.title').substring(0, 110),
            _a[IDs.DESCRIPTION] = get(item, 'post.description'),
            _a[IDs.POST_PAGE_URL] = get(item, 'post.postPageUrl') || get(item, 'post.canonicalUrl'),
            _a[IDs.COVER_IMAGE] = get(item, 'post.image.url'),
            _a[IDs.COVER_IMAGE_HEIGHT] = get(item, 'post.image.height'),
            _a[IDs.COVER_IMAGE_WIDTH] = get(item, 'post.image.width'),
            _a[IDs.AUTHOR] = get(item, 'post.owner.name'),
            _a[IDs.AUTHOR_IMAGE_URL] = get(item, 'post.owner.image.url'),
            _a[IDs.AUTHOR_IMAGE_HEIGHT] = get(item, 'post.owner.image.height'),
            _a[IDs.AUTHOR_IMAGE_WIDTH] = get(item, 'post.owner.image.width'),
            _a[IDs.PUBLISHER_ID] = get(item, 'post.publisher.id'),
            _a[IDs.PUBLISHER_NAME] = get(item, 'post.publisher.name'),
            _a[IDs.PUBLISH_DATE] = get(item, 'post.firstPublishedDate'),
            _a[IDs.LAST_MODIFIED_DATE] = get(item, 'post.lastPublishedDate'),
            _a[IDs.AMP_URL] = get(item, 'post.amphtml'),
            _a[IDs.DISABLE_SCHEMA] = !getRawValue(item, 'postsSettings.isSchemaEnabled'),
            _a[IDs.DISABLE_AMP] = !getRawValue(item, 'postsSettings.isAmpEnabled'),
            _a[IDs.CATEGORIES] = get(item, 'post.categories'),
            _a[IDs.SD_DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a);
        data[IDs.SD_JSON_RENDER] = renderStructureData(item, data, IDs);
        return data;
    },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
        return { tags: tags };
    },
    getBiData: function () {
        return {};
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSlug: function (item) { return get(item, 'post.slug'); },
    updateItemDataWithSlug: function (item) { return item; },
};
